import { render, staticRenderFns } from "./Step4-shade.vue?vue&type=template&id=6ea447bd&scoped=true&"
import script from "./Step4-shade.vue?vue&type=script&lang=js&"
export * from "./Step4-shade.vue?vue&type=script&lang=js&"
import style0 from "./Step4-shade.vue?vue&type=style&index=0&id=6ea447bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea447bd",
  null
  
)

export default component.exports